var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHcIconMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33a3dc",
    d: "M167.86 43.08l-65.77-27.31a5.53 5.53 0 00-4.18 0L32.14 43.08a5.44 5.44 0 00-3.36 5v33.23a111.09 111.09 0 0069.16 102.93 5.5 5.5 0 004.12 0 111.09 111.09 0 0069.16-102.93V48.12a5.44 5.44 0 00-3.36-5.04zm-7.54 9.52v28.71a100.24 100.24 0 01-59.81 91.74l-.51.23-.51-.23a100.23 100.23 0 01-59.81-91.74V51.76l.78-.33 59.06-24.52.48-.2.48.2 59.06 24.52.78.33z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8ae15",
    d: "M111.34 125.72H88.7a3.84 3.84 0 01-3.83-3.83v-10.47H74.34a3.83 3.83 0 01-3.83-3.82V84.91a3.83 3.83 0 013.83-3.83H84.8V70.57a3.83 3.83 0 013.83-3.83h22.67a3.83 3.83 0 013.83 3.83v10.49h10.53a3.83 3.83 0 013.83 3.83v22.74a3.84 3.84 0 01-3.83 3.83h-10.49v10.43a3.83 3.83 0 01-3.83 3.83zm-18.81-7.66h15v-10.43a3.84 3.84 0 013.83-3.83h10.49V88.72H111.3a3.84 3.84 0 01-3.83-3.83V74.4h-15v10.51a3.83 3.83 0 01-3.83 3.83H78.17v15H88.7a3.83 3.83 0 013.83 3.83z"
  })));
}

export default SvgHcIconMaintenance;